import './App.css';
import Navbar from './Navbar';
import About from './About';
import { BrowserRouter , Routes , Route  } from "react-router-dom";
import Cards from './Cards';
import Hero from './Hero';
import Body from './Body';
import Deployment from './Deployment';
import Secure from './Secure';
import Admin from './Admin';
import { Navigate } from "react-router-dom";
import Dashboard from './Dashboard';
function App() {
  return (

<>

<Routes>
  <Route path='/' element  = {<Navbar/>}/>
  <Route path='/dashboard' element = {<Dashboard/>}/>
<Route path='/about' element = {<About/>}/>
<Route path='/auth' element = {<Secure/>}/>
<Route path='/admin' element = {<Admin/>}/>
</Routes>
  </>
  );
}

export default App;
